import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/usr/app/node_modules/@chakra-ui/react/dist/esm/components/text/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/app/[locale]/(profile)/about/ui/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/shared/ui/container/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/shared/ui/logo/index.tsx");
